<div
        cdkDropList
        class="border rounded border-gray-300"
        (cdkDropListDropped)="drop($event)"
        >
        <div
            class="task-box text-lg"
            *ngFor="let job of jobs; let i = index"
            [cdkDragData]="job"
            cdkDrag
            >
            <div class="flex w-full justify-between">
                <div class="flex items-center">
                    <em class="ti ti-grid-dots mr-3 text-2xl"></em>
                    <div>
                        <p class="font-semibold">
                            <i class="ti ti-repeat mr-2" *ngIf="job?.is_recurrence"></i>
                            #<span *ngIf="job?.prefix">{{job?.prefix}} </span><span *ngIf="job?.work_order_number">{{job?.work_order_number}} </span>{{job?.job_title}}
                        </p>
                        <div class="flex flex-col space-y-2 primary-font text-base font-normal text-gray-700">
                            <span *ngIf="job?.customer?.customer_first_name" class="mt-1">
                                <i class="ti ti-user text-2xl mr-2"></i>
                                <span>{{job?.customer?.customer_first_name}} {{job?.customer?.customer_last_name}}</span>
                            </span>
                            <span *ngIf="job?.organization?.organization_name" class="mt-1">
                                <i class="ti ti-building text-2xl mr-2"></i>
                                <span>{{job?.organization?.organization_name}}</span>
                            </span>
                            <div class="flex my-1" *ngIf="job?.scheduled_start_time && job?.scheduled_end_time">
                                <i class="ti ti-calendar-minus text-2xl"></i>
                                <span class="text-base ml-1">{{job?.scheduled_start_time | datetime: dateTimeFormat: timezone}} - {{job?.scheduled_end_time | datetime: dateTimeFormat: timezone}}</span>
                            </div>
                            <div class="flex my-1" *ngIf="!(job?.scheduled_start_time && job?.scheduled_end_time) && job?.due_date">
                                <i class="ti ti-calendar-minus text-2xl"></i>
                                <span class="text-base ml-1">{{'text.due_by' | translate}} {{job?.due_date | datetime: dateTimeFormat: timezone}}</span>
                            </div>
                            <span *ngIf="job?.customer_address?.street" class="mt-1">
                                <i class="ti ti-map-pin text-2xl mr-2"></i>
                                <span *ngIf="job?.customer_address">{{getJobCustomerAddress(job)}}</span>
                            </span>
                        </div>
                        <p class="text-red-500 mt-1" *ngIf="showRouteAlert && job?.route?.route_name && job?.route?.route_uid !== routeDetails?.route_uid ">
                            {{'text.already_assigned_to_route' | translate}}: '{{job?.route?.route_name}}'
                        </p>
                    </div>
                </div>
                <i class="ti ti-trash text-2xl mx-2 text-red-500" *ngIf="canRemove" (click)="removeJob(i)" title="{{'alert.remove_job_from_route' | translate}}"></i>
            </div>
        </div>
    </div>